import { AuthGuard } from "@ssf/auth-components";
import { Loading, useTrackPageChange } from "@ssf/components";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router";

import { generatePath, routes } from "../lib/index.js";

const LobbyPage = lazy(() => import("../pages/LobbyPage.jsx"));
const SettingsPage = lazy(() => import("../pages/SettingsPage.jsx"));
const GamePage = lazy(() => import("../pages/GamePage.jsx"));
const CreateTournamentPage = lazy(
  () => import("../pages/CreateTournamentPage.jsx"),
);
const MemdbRedirectPage = lazy(() => import("../pages/MemdbRedirectPage.jsx"));
const EnginePage = lazy(() => import("../pages/EnginePage.jsx"));
const TournamentsPage = lazy(() => import("../pages/TournamentsPage.jsx"));

export const Router = () => {
  const location = useLocation();

  useTrackPageChange();

  return (
    <Routes>
      <Route
        path={routes.home}
        element={
          <Navigate
            to={generatePath("lobby", { room: "lobby" }) + location.search}
            replace
          />
        }
      />
      <Route
        path={routes.memdbRedirect}
        element={
          <Suspense fallback={<Loading />}>
            <MemdbRedirectPage />
          </Suspense>
        }
      />
      <Route
        path={routes.createTournament}
        element={
          <AuthGuard autoSignin>
            <Suspense fallback={<Loading />}>
              <CreateTournamentPage />
            </Suspense>
          </AuthGuard>
        }
      />
      <Route
        path={routes.engine}
        element={
          <Suspense fallback={<Loading />}>
            <EnginePage />
          </Suspense>
        }
      />
      <Route
        path={routes.tournaments}
        element={
          <AuthGuard autoSignin>
            <Suspense fallback={<Loading />}>
              <TournamentsPage />
            </Suspense>
          </AuthGuard>
        }
      />
      <Route
        path={routes.lobby}
        element={
          <Suspense fallback={<Loading />}>
            <LobbyPage />
          </Suspense>
        }
      />
      <Route
        path={routes.settings}
        element={
          <Suspense fallback={<Loading />}>
            <SettingsPage />
          </Suspense>
        }
      />
      <Route
        path={routes.game}
        element={
          <Suspense fallback={<Loading />}>
            <GamePage />
          </Suspense>
        }
      />
    </Routes>
  );
};
